import { render, staticRenderFns } from "./VentaEditarModalPerseo.vue?vue&type=template&id=735c6a50&scoped=true"
import script from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
export * from "./VentaEditarModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./VentaEditarModalPerseo.vue?vue&type=style&index=0&id=735c6a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c6a50",
  null
  
)

export default component.exports